<template>
    <div class="content-full">
        <div id="content" class="full">
            <div id="dossiers" class="ecran bloc col-lg-12 col-md-12 col-sm-12 col-xs-12" style="display:block;">
                <div class="content-bloc">
                    <ul class="lst-saisie" id="lst-saisie">
                        <template v-for="value in demandes">
                            <li @click="goToDossier(value)">
                                <div class="col-1 text-center no-padding">
                                    <div class="btn-type">
                                        <font-awesome-icon v-if="value.marker == 'odp_travaux'"
                                            icon="wrench"></font-awesome-icon>
                                        <font-awesome-icon v-if="value.marker == 'odp_demenagement'"
                                            icon="archive"></font-awesome-icon>
                                        <font-awesome-icon v-if="value.marker == 'odp_stationnement'"
                                            icon="car"></font-awesome-icon>
                                        <div class="hover-thumb">
                                            <font-awesome-icon icon="eye"></font-awesome-icon>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="title-saisie">{{ value.ident }}</div>
                                    <div class="date-saisie">- {{ value.date_demande }}</div>
                                    <div class="infos-saisie">
                                        <div class="user-saisie">
                                            <font-awesome-icon icon="user"></font-awesome-icon>
                                            <template v-if="value.prenom == ''"> {{ value.raison_sociale }}</template>
                                            <template v-else> {{ value.prenom }} {{ value.nom }}</template>
                                        </div>
                                        <div class="separator-saisie">-</div>
                                        <div class="adresse-saisie">
                                            <i class="fa fa-map-marker"></i>
                                            {{ value.adresse_marqueur }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3 text-center no-padding">
                                    <div class="actions-saisie">
                                        <div v-if="value.etat == 1" class="btn-action red">
                                            <font-awesome-icon icon="paper-plane"></font-awesome-icon>
                                        </div>
                                        <div v-else-if="value.etat == 2" class="btn-action green">
                                            <font-awesome-icon icon="paper-plane"></font-awesome-icon>
                                        </div>
                                        <div v-else-if="value.etat == 3" class="btn-action purple">
                                            <font-awesome-icon icon="paper-plane"></font-awesome-icon>
                                        </div>
                                        <div v-else class="btn-action gray">
                                            <font-awesome-icon icon="paper-plane"></font-awesome-icon>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3 text-center no-padding">
                                    <div class="actions-saisie">
                                        <div v-if="value.etat == 2" class="btn-action green">
                                            <font-awesome-icon icon="check"></font-awesome-icon>
                                        </div>
                                        <div v-else-if="value.etat == 3" class="btn-action purple">
                                            <font-awesome-icon icon="check"></font-awesome-icon>
                                        </div>
                                        <div v-else class="btn-action gray">
                                            <font-awesome-icon icon="check"></font-awesome-icon>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3 text-center no-padding">
                                    <div class="actions-saisie">
                                        <div v-if="value.etat == 3" @click="openArrete(value)" class="btn-action purple">
                                            <font-awesome-icon icon="gavel"></font-awesome-icon>
                                        </div>
                                        <div v-else class="btn-action gray">
                                            <font-awesome-icon icon="gavel"></font-awesome-icon>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>

        <b-modal id="modal_legende" size="lg" title="Légende" :ok-only="true" ok-title="Fermer">
            <div id="content_modal" class="full" style="font-size: 15px;">
                <ul class="lst-saisie">
                    <li>
                        <div class="btn-action gray"></div>
                        <span style="line-height: 50px;margin-left: 15px;">Déposé sur Clicmap</span>
                    </li>
                    <li>
                        <div class="btn-action"></div>
                        <span style="line-height: 50px;margin-left: 15px;">Envoyé à la modération</span>
                    </li>
                    <li>
                        <div class="btn-action green"></div>
                        <span style="line-height: 50px;margin-left: 15px;">Demande acceptée</span>
                    </li>
                    <li>
                        <div class="btn-action purple"></div>
                        <span style="line-height: 50px;margin-left: 15px;">Arrêté généré</span>
                    </li>
                </ul>
            </div>
        </b-modal>

        <div id="footer">
            <div id="footer_accueil" class="barre-footer">
                <ul class="lst-outils">
                    <li class="col-lg-12 col-md-12 col-sm-12 col-xs-12 gray" v-b-modal.modal_legende style="float: left;">
                        <font-awesome-icon icon="info-circle"></font-awesome-icon> Légende
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Vuex from "vuex";
import router from "../router/index.js";
import Vue from "vue";

export default {
    name: "Assignation",
    mounted() {
        this.getDemandes({ dossier: JSON.parse(localStorage['env_assign']).dos_cod_t });

        // if (JSON.parse(localStorage['user_connected']).userId == 2139)
        this.setNeedReturn(true);
        // else
        // this.setNeedReturn(false);
    },
    computed: {
        ...Vuex.mapGetters("Demande", ["demandes"]),
        ...Vuex.mapGetters("Application", ["needReturn"]),
    },
    methods: {
        openArrete(dossier) {
            window.open(dossier.lnk);
        },
        goToDossier(dossier) {
            router.push({
                name: "ficheAssign",
                params: { id: dossier.id, layername: dossier.marker },
            });
        },
        ...Vuex.mapActions("Demande", ["getDemandes"]),
        ...Vuex.mapActions("Application", ["setNeedReturn"]),
    },
};
</script>

<style scoped></style>